import React from "react";
import ReactPaginate from "react-paginate";

const CommonPagination = ({
  pageCount = 1,
  currentPage = 1,
  onPageChange = () => {},
}) => {
  return (
    <>
      {pageCount > 1 && (
        <div className="flex items-center justify-center gap-2 mt-6">

          {/* First Page */}
          <button
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            className="border border-border rounded-md px-3 py-1 text-sm disabled:opacity-50"
          >
            «
          </button>

          <ReactPaginate
            breakLabel="..."
            previousLabel="←"
            nextLabel="→"
            pageCount={pageCount}
            forcePage={currentPage - 1}
            onPageChange={(e) => onPageChange(e.selected + 1)}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            containerClassName="flex items-center justify-center gap-2"
            pageClassName="border border-border rounded-md"
            pageLinkClassName="px-3 py-1 w-full h-full flex items-center justify-center text-sm cursor-pointer hover:bg-muted"
            activeClassName="bg-primary border-primary"
            activeLinkClassName="text-white font-medium"
            previousClassName="border border-border rounded-md"
            previousLinkClassName="px-3 py-1 flex items-center justify-center cursor-pointer"
            nextClassName="border border-border rounded-md"
            nextLinkClassName="px-3 py-1 flex items-center justify-center cursor-pointer"
            breakClassName="border border-border rounded-md"
            breakLinkClassName="px-3 py-1 text-muted-foreground"
            disabledClassName="opacity-50"
            disabledLinkClassName="pointer-events-none"
          />

          {/* Last Page */}
          <button
            onClick={() => onPageChange(pageCount)}
            disabled={currentPage === pageCount}
            className="border border-border rounded-md px-3 py-1 text-sm disabled:opacity-50"
          >
            »
          </button>

        </div>
      )}
    </>
  );
};

export default CommonPagination;